
import quyenTruyCapActions from './quyenTruyCapActions'

import roleActions from './roleActions'
import nguoiDungActions from './nguoiDungActions'
import displayModalActions from './displayModalActions'
const allActions = {
    quyenTruyCapActions,
    roleActions,
    nguoiDungActions,
    displayModalActions
}

export default allActions